module.exports = __webpack_public_path__ + "img/ep_search.f3ede208.svg";